export const LOOKUP_VIEW_PATH = "/campaigns/lookup";
